import axios from "axios"
import { API_BASE_URL } from "../config/api"

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
})

export const publicApiClient = axios.create({
  baseURL: API_BASE_URL,
});

// export const apiClient = axios.create({
//   baseURL: "http://localhost/toyfront/wp-json",
// })

// Request interceptor for adding auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("auth_token")
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

// Response interceptor for handling errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("auth_token")
      localStorage.removeItem("user_data")
      window.location.href = "/login"
    }
    return Promise.reject(error)
  },
)

export default apiClient
